import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}')({
  beforeLoad: () => getTitleContextSlice('Asset Aging'),
  staticData: {
    owner: CodeOwner.DataFabric,
  },
});
